import { IonList, IonItem, IonText } from '@ionic/react';
import { useNavigate } from 'react-router-dom';
import type { GetMatchesQuery, GetSeasonCompetitionTeamsQuery } from '../../../../types/graphql-generated';

type Standing = NonNullable<GetMatchesQuery['getMatches']>['standings'][number];
type SeasonCompetitionTeamEntry = NonNullable<
  NonNullable<GetSeasonCompetitionTeamsQuery['getSeasonCompetitionTeams']>['teams'][number]
>;

interface MatchWeekStandingsProps {
  standings: Standing[];
  seasonCompetitionTeams: SeasonCompetitionTeamEntry[];
  currentWeekNumber?: number;
}

const teamIdToSctId = (teamId: string, seasonCompetitionTeams: SeasonCompetitionTeamEntry[]): string | undefined =>
  seasonCompetitionTeams.find((sct) => sct.team.id === teamId)?.id;

export const MatchWeekStandings: React.FC<MatchWeekStandingsProps> = ({
  standings,
  seasonCompetitionTeams,
  currentWeekNumber,
}) => {
  const navigate = useNavigate();

  const navigateToRoster = (sctId: string) => {
    navigate(`/app/main/competition/plantilla/${sctId}`);
  };

  if (standings.length > 0) {
    return (
      <div>
        {/* Header */}
        <div
          style={{
            padding: '6px 12px',
            borderBottom: '1px solid #ddd',
            backgroundColor: '#f5f5f5',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '32px 1fr 40px 36px 65px',
              fontWeight: 'bold',
              fontSize: '11px',
              color: '#666',
              alignItems: 'center',
            }}
          >
            <span>Pos</span>
            <span>Equipo</span>
            <span style={{ textAlign: 'center' }}>Pts</span>
            <span style={{ textAlign: 'center' }}>PJ</span>
            <span style={{ textAlign: 'center' }}>GF-GC</span>
          </div>
        </div>

        {/* Standings list */}
        <IonList style={{ padding: 0 }}>
          {standings.map((standing) => {
            const sctId = teamIdToSctId(standing.team.id, seasonCompetitionTeams);
            return (
              <IonItem
                key={standing.id}
                button={!!sctId}
                onClick={sctId ? () => navigateToRoster(sctId) : undefined}
                style={{ cursor: sctId ? 'pointer' : 'default', '--padding-start': '12px', '--padding-end': '12px', '--inner-padding-end': '0px', '--min-height': '44px' }}
              >
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '32px 1fr 40px 36px 65px',
                    width: '100%',
                    alignItems: 'center',
                    fontSize: '14px',
                  }}
                >
                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{standing.position}</span>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    {standing.team.shield && (
                      <img
                        src={standing.team.shield}
                        alt={standing.team.nameShow}
                        style={{ width: '20px', height: '20px', objectFit: 'contain' }}
                      />
                    )}
                    <span style={{ fontSize: '13px' }}>{standing.team.nameShow}</span>
                  </div>

                  <span style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14px' }}>{standing.points}</span>
                  <span style={{ textAlign: 'center', fontSize: '13px' }}>{standing.played}</span>
                  <span style={{ textAlign: 'center', fontSize: '12px' }}>
                    {standing.goalsFor}-{standing.goalsAgainst}
                  </span>
                </div>
              </IonItem>
            );
          })}
        </IonList>
      </div>
    );
  }

  if (currentWeekNumber === 1 && seasonCompetitionTeams.length > 0) {
    return (
      <>
        <IonText color="medium">
          <p className="ion-padding">
            Esta es la lista de equipos participantes. Accede a ellos para ver sus plantillas
          </p>
        </IonText>
        <IonList style={{ padding: 0 }}>
          {seasonCompetitionTeams.map((sct) => (
            <IonItem
              key={sct.id}
              button
              onClick={() => navigateToRoster(sct.id)}
              style={{ cursor: 'pointer', '--padding-start': '12px', '--padding-end': '12px', '--inner-padding-end': '0px', '--min-height': '44px' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
                {sct.team.shield && (
                  <img
                    src={sct.team.shield}
                    alt={sct.team.nameShow}
                    style={{ width: '24px', height: '24px', objectFit: 'contain' }}
                  />
                )}
                <span style={{ fontSize: '14px' }}>{sct.team.nameShow}</span>
              </div>
            </IonItem>
          ))}
        </IonList>
      </>
    );
  }

  return (
    <IonText color="medium">
      <p className="ion-padding">No hay clasificación para esta jornada</p>
    </IonText>
  );
};
